import { Core } from "@faire/design-tokens";
import { Badge } from "@faire/web--source/slate/Badge";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { IProductsResponse } from "@faire/web-api--source/indigofair/data/IProductsResponse";
import React from "react";
import styled from "styled-components";

import { CollapsibleContainer } from "./CollapsibleContainer";

export const ProductAttributeTagsMobile: React.FunctionComponent<
  ProductAttributeTags.IProps
> = ({ productAttributeTags }) => {
  const attributeTags = productAttributeTags.map((attribute) => {
    return attribute.display_name ? (
      <AttributeTag
        key={attribute.display_name}
        content={attribute.display_name}
        backgroundColor={Core.surface.subdued}
      />
    ) : null;
  });
  return <AttributeRowWrapperMobile>{attributeTags}</AttributeRowWrapperMobile>;
};

export const ProductAttributeTagsTabletAndAbove: React.FunctionComponent<
  ProductAttributeTags.IProps
> = ({ productAttributeTags }) => {
  const attributeTags = productAttributeTags.map((attribute) => {
    return attribute.display_name ? (
      <AttributeTag
        key={attribute.display_name}
        content={attribute.display_name}
        backgroundColor={Core.surface.subdued}
      />
    ) : null;
  });
  return (
    <AttributeTagPillsContainer>
      <CollapsibleContainer thresholdHeight={ATTRIBUTE_TAG_HEIGHT * 2}>
        <AttributeRowWrapper>{attributeTags}</AttributeRowWrapper>
      </CollapsibleContainer>
    </AttributeTagPillsContainer>
  );
};

namespace ProductAttributeTags {
  export interface IProps {
    productAttributeTags: Array<IProductsResponse.IProductAttributeTag>;
  }
}

// eslint-disable-next-line @faire/prefer-slate-attrs -- false alarm
const AttributeRowWrapperMobile = styled(Row).attrs({ gap: "1x" })`
  white-space: nowrap;
  padding-top: ${getSpacing("3x")};
  overflow-y: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

// eslint-disable-next-line @faire/prefer-slate-attrs
const AttributeRowWrapper = styled(Row)`
  flex-wrap: wrap;
  gap: ${getSpacing("1x", "1x")};
`;

const AttributeTagPillsContainer = styled(Row)`
  padding-top: ${getSpacing("3x")};
`;

// This constant is used to calculate the threshold height to collapse tag pills
// If you are changing the size of the tag pill, please update this
const ATTRIBUTE_TAG_HEIGHT = 28;

const AttributeTag = styled(Badge)`
  padding: 4px 12px;
  min-width: auto;
`;
